import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormFileInputField from 'modules/ui/editform/fields/EditFormFileInputField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import EditFormComponentMassSomethingField from 'app/admin/common/component/EditFormComponentMassSomethingField';
import WorkflowModelCalculate from 'app/admin/common/component/WorkflowModelCalculate';
import { useParams, withRouter } from 'react-router';
import StorageDriverService from 'app/admin/driver/service/StorageDriverService';
// import EntriesListComponent from 'app/admin/model/component/EntriesListComponent';
import WorkflowProvider from 'app/admin/workflow/component/WorkflowProvider';
import WorkflowModelEditService from '../service/WorkflowModelEditService';
import WorkflowEditFormHeader from '../component/WorkflowEditFormHeader';
import WorkflowEditFormComponent from '../component/WorkflowEditFormComponent';
import WorkflowModelDebug from '../component/WorkflowModelDebug';
import WorkflowDataUpdater from '../component/WorkflowDataUpdater';
// import WorkflowInputUpdater from '../component/WorkflowInputUpdater';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	const storageDriverService = new StorageDriverService();
	return {
		key: 'workflowModelEditForm',
		topic: 'model',
		service: WorkflowModelEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'inputAttributes' }, { key: 'outputAttributes' }, { key: 'workflow' }/*, { key: 'entries' }*/];
		},
		backLink: () => '/model',
		defaultValue: () => WorkflowModelEditService.create(data.driverName),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'driver',
					component: EditFormSelectField,
					required: true,
					items: () => storageDriverService.getListSelectionByDriverType('workflow')
				},
				{
					key: 'version',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new',
				},
				{
					key: 'workflow',
					component: WorkflowEditFormComponent,
					isControlledInput: false,
					tab: 'workflow'
				},
				{
					key: 'workflowDataUpdater',
					component: WorkflowDataUpdater,
					isControlledInput: false,
					tab: 'workflow'
				},
				// {
				// 	key: 'workflowDataUpdater_inputAttributes',
				// 	component: WorkflowDataUpdater,
				// 	isControlledInput: false,
				// 	tab: 'inputAttributes'
				// },
				{
					key: 'image',
					component: EditFormFileInputField,
					showImage: true,
					required: true
				},
				{
					key: 'inputAttributes',
					tab: 'inputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					modifyOnly: true,
					defaultValue: {
						id: null,
						name: null,
						type: null,
						value: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: [
								{ label: 'Variable', value: 'Variable' },
								{ label: 'ComponentMoleFlow', value: 'ComponentMoleFlow' },
								{ label: 'ComponentMassFrac', value: 'ComponentMassFrac' },
								{ label: 'ComponentMassFlow', value: 'ComponentMassFlow' },
								{ label: 'DistillationCurve', value: 'DistillationCurve' },
								{ label: 'SpreadSheet', value: 'SpreadSheet' }
							]
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							type: 'number',
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'minValue',
							component: EditFormTextField,
							type: 'number',
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'maxValue',
							component: EditFormTextField,
							type: 'number',
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'uom',
							component: EditFormTextField,
						},
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							dependsOn: 'type',
							visibleIf: type => (type === 'ComponentMoleFlow' || type === 'ComponentMassFrac' || type === 'ComponentMassFlow' || type === 'DistillationCurve')
						}
					]
				},
				{
					key: 'outputAttributes',
					tab: 'outputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					modifyOnly: true,
					defaultValue: {
						id: null,
						name: null,
						type: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: [
								{ label: 'Variable', value: 'Variable' },
								{ label: 'ComponentMoleFlow', value: 'ComponentMoleFlow' },
								{ label: 'ComponentMassFrac', value: 'ComponentMassFrac' },
								{ label: 'ComponentMassFlow', value: 'ComponentMassFlow' },
								{ label: 'DistillationCurve', value: 'DistillationCurve' }
							]
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							type: 'number',
							dependsOn: 'type',
							visibleIf: type => type === 'Variable'
						},
						{
							key: 'uom',
							component: EditFormTextField,
						},
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							dependsOn: 'type',
							visibleIf: type => (type === 'ComponentMoleFlow' || type === 'ComponentMassFrac' || type === 'ComponentMassFlow' || type === 'DistillationCurve')
						}
					]
				}
			];

			return fields;
		}
	};
};

function WorkflowModelEditForm() {
	const { id, driverName } = useParams();
	const dispatch = useDispatch();
	const myConfig = config({ id, driverName });

	return (
		<WorkflowProvider>
			<EditFormPage
				config={myConfig}
				beforeSaveContent={<>
					<WorkflowModelDebug id={id} />
					<WorkflowModelCalculate id={id} />
				</>}
				headerCenterContent={<WorkflowEditFormHeader workflowTab={3} />}
			/>
		</WorkflowProvider>
	);
}

export default withRouter(WorkflowModelEditForm);